import React from 'react';

export const WorkListReports = props => {
  const workProps = {
    headerTitle: '帳票印刷',
    contentTitle:
      '検索条件で選択した内容で帳票を印刷します。帳票のファイル形式を選択してください。',
    ...props,
  };
  return <ListReports {...workProps} />;
};

export const ListReports = props => {
  const { reportData, onPrint, onClose, headerTitle, contentTitle } = props;

  const elementName = 'ListReports';
  return (
    <div className={`${elementName}`}>
      <div className={`${elementName}__header`}>
        <span data-testid='list-report-header'>{headerTitle}</span>
      </div>
      <div className={`${elementName}__body`}>
        <div
          className={`${elementName}__body-title`}
          data-testid='list-report-body-title'
        >
          {contentTitle}
        </div>
        <div
          className={`${elementName}__body-header`}
          data-testid='list-report-body-header'
        >
          <table className={`${elementName}__body-table`}>
            <thead>
              <tr>
                <td
                  className={`${elementName}__body-table-cell ${elementName}__body-table-cell--header`}
                  data-testid='list-report-body-table-cell--header'
                >
                  帳票名
                </td>
                <td
                  className={`${elementName}__body-table-cell ${elementName}__body-table-cell--header`}
                  data-testid='list-report-body-table-cell--header'
                >
                  ファイル形式
                </td>
              </tr>
            </thead>
          </table>
        </div>
        <div className={`${elementName}__body-content`}>
          <table className={`${elementName}__body-table`}>
            <tbody>
              {reportData.length > 0 ? (
                reportData.map((report, index) => {
                  return (
                    <Report
                      key={index}
                      report={report}
                      printReport={onPrint}
                      elementName={elementName}
                    />
                  );
                })
              ) : (
                <tr
                  className={`${elementName}__body-table-row`}
                  data-testid='list-report-body-table-row-empty'
                />
              )}
            </tbody>
          </table>
        </div>
      </div>
      <div className={`${elementName}__footer`}>
        <button
          id='modal-close-document'
          className={`btn-fixedsize--sub ${elementName}__button ${elementName}__button--close`}
          data-testid='close-button'
          onClick={() => onClose()}
        >
          閉じる
        </button>
      </div>
    </div>
  );
};

const Report = props => {
  const { report, printReport, elementName } = props;
  return (
    <tr
      className={`${elementName}__body-table-row`}
      data-testid='list-report-body-table-row'
    >
      <td
        className={`${elementName}__body-table-cell ${elementName}__body-table-cell--content`}
        data-testid='list-report-body-table-cell--content'
      >
        {report.report_name}
      </td>

      <td
        className={`${elementName}__body-table-cell ${elementName}__body-table-cell--content`}
      >
        <button
          className={`btn--sub ${elementName}__button ${elementName}__button--export`}
          data-testid='export-form-button'
          onClick={() => printReport(report, false)}
          style={{
            visibility: report.printout_excel_flag ? 'visible' : 'hidden',
          }}
        >
          Excelで出力
        </button>
        <button
          className={`btn--sub ${elementName}__button ${elementName}__button--export`}
          data-testid='export-form-button'
          onClick={() => printReport(report, true)}
          style={{
            visibility: report.printout_pdf_flag ? 'visible' : 'hidden',
          }}
        >
          PDFで出力
        </button>
      </td>
    </tr>
  );
};



// WEBPACK FOOTER //
// ./src/components/modals/ListReports.jsx